var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.66669,
    y: 3.66666,
    width: 6.41667,
    height: 6.41667,
    rx: 1.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 5.16666C11.9167 4.33823 12.5883 3.66666 13.4167 3.66666H16.8334C17.6618 3.66666 18.3334 4.33823 18.3334 5.16666V8.58332C18.3334 9.41175 17.6618 10.0833 16.8334 10.0833H13.4167C12.5883 10.0833 11.9167 9.41175 11.9167 8.58332V5.16666ZM3.66669 13.4167C3.66669 12.5882 4.33826 11.9167 5.16669 11.9167H8.58335C9.41178 11.9167 10.0834 12.5882 10.0834 13.4167V16.8333C10.0834 17.6617 9.41178 18.3333 8.58335 18.3333H5.16669C4.33826 18.3333 3.66669 17.6617 3.66669 16.8333V13.4167ZM13.4167 11.9167C12.5883 11.9167 11.9167 12.5882 11.9167 13.4167V16.8333C11.9167 17.6617 12.5883 18.3333 13.4167 18.3333H16.8334C17.6618 18.3333 18.3334 17.6617 18.3334 16.8333V13.4167C18.3334 12.5882 17.6618 11.9167 16.8334 11.9167H13.4167Z",
    fill: "#212121"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0a8184521f1a4c1692fb1a620c424ae2.svg";
export { ForwardRef as ReactComponent };